<template>
    <modal-window v-on:close="$emit('closeSaveChangesWindow')">
        <template slot="header">
            <p class="modal-card-title">Save changes</p>
            <button class="delete" v-on:click="$emit('closeSaveChangesWindow')" aria-label="close"></button>
        </template>
        <template slot="body">
            <div class="field">
                <label class="label">Select file type</label>
                <div class="control">
                    <label class="radio">
                        <input type="radio" value="txt" v-model="fileType"> Text
                    </label>
                </div>
                <div class="control">
                    <label class="radio">
                        <input type="radio" value="markdown" v-model="fileType"> Markdown
                    </label>
                </div>
            </div>

            <div class="field">
                <label class="label">Choose how many versions to include in the log (0 = everything)</label>
                <div class="control">
                    <label class="number">
                        <input type="number" value="all" v-model="versionDepth">
                    </label>
                </div>
            </div>

            <div class="field">
                <label class="label">Select language</label>
                <div class="control">
                    <label class="radio">
                        <input type="radio"
                               value="english"
                               v-model="language"
                               v-bind:disabled="fileType == 'json'"> English
                    </label>
                </div>
                <div class="control">
                    <label class="radio">
                        <input type="radio"
                               value="russian"
                               v-model="language"
                               v-bind:disabled="fileType == 'json'"> Russian
                    </label>
                </div>
            </div>

            <div class="field">
                <label class="label">Group by</label>
                <div class="control">
                    <label class="radio">
                        <input type="radio"
                               value="minor"
                               v-model="grouping"
                               v-bind:disabled="isGroupingDisabled"> Minor
                    </label>
                </div>
                <div class="control">
                    <label class="radio">
                        <input type="radio"
                               value="build"
                               v-model="grouping"
                               v-bind:disabled="isGroupingDisabled"> Build
                    </label>
                </div>
            </div>

            <div class="field">
                <label class="label">
                    <input type="checkbox"
                           value="false"
                           v-model="includePrivate" />
                    Include private changes
                </label>
            </div>

            <loading :active.sync="loading" :can-cancel="false" :is-full-page="false"></loading>
        </template>
        <template slot="footer">
            <a id="downloadBtn"
               class="button is-success"
               v-bind:download="filename"
               v-on:click="downloadChanges">Download</a>
            <!--<button class="button is-success" v-on:click="preview">Preview</button>-->
            <button class="button" v-on:click="$emit('closeSaveChangesWindow')">Cancel</button>
        </template>
    </modal-window>
</template>

<script>
    import ModalWindow from "./ModalWindow";
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.min.css";
    import * as downloader from "./download";

    export default {
        name: "combined-change-saver",
        components: { ModalWindow, Loading },
        props: {
            groupId: Number,
            filterType: String
        },
        data() {
            return {
                versionDepth: 0,
                language: "english",
                fileType: "txt",
                grouping: "build",
                version: -1,
                includePrivate: false,

                fileLink: "",
                filename: "",
                tags: [],
                loading: false
            };
        },
        methods: {
            downloadChanges() {
                this.loading = true;
                this.HTTP.post("changes/group/file", {
                    groupId: this.groupId,
                    fileType: this.fileType,
                    grouping: this.grouping,
                    filterType: this.includePrivate ? "all" : "public",
                    fileType: this.fileType,
                    language: this.language,
                    versionDepth: this.versionDepth
                })
                    .then(response => {
                        let downloadingTxt;
                        let chgs = response.data;
                        if (chgs.length == 0)
                            chgs += "\nThere is no changes!";
                        let btype = "text/plain";
                        if (this.fileType == "txt" || this.fileType == "markdown") {
                            this.filename =
                                this.fileType == "markdown" ? "changes.md" : "changes.txt";
                            btype = "text/plain";
                            downloadingTxt = chgs;
                        } else {
                            this.filename = "changes.json";
                            btype = "application/json";
                            downloadingTxt = JSON.stringify(chgs);
                        }
                        let blob = new Blob([downloadingTxt]);
                        downloader.download(blob, this.filename, btype);

                        this.loading = false;
                        this.$emit("closeSaveChangesWindow");
                    })
                    .catch(e => {
                        console.log(e);
                    });
            },
        },
        created() { },
    };
</script>



// WEBPACK FOOTER //
// src/components/CombinedChangesSaver.Vue